export default __webpack_public_path__ + "static/media/posizioni_professionali.6333aef7.less";